import React from 'react'
import { connect } from 'react-redux'

import { createNote } from 'data/notes/actions'

import ShortcutHelpers from 'helpers/ShortcutHelpers'

import Wrapper from '../Wrapper'
import noNoteSelected from 'assets/images/no-note-selected.svg'
import ShortcutLabel from 'components/Utils/ShortcutLabel'

const image = (
  <img src={noNoteSelected} alt="no-connection" style={{ width: 140 }} />
)

export default connect(
  null,
  { createNote }
)(function NoNoteSelected({ createNote }) {
  return (
    <Wrapper
      image={image}
      title={'No selected doc'}
      goBackButton={false}
      subtitle={
        <div className="flexbox flexbox-align-center flexbox-wrap">
          <div>
            <span
              className="pointer shade-05-on-hover"
              onClick={() => createNote()}
            >
              Create one
            </span>
            <span> or hit</span>
          </div>
          <ShortcutLabel className="margin-horizontal-smaller">
            {ShortcutHelpers.quickSwitch}
          </ShortcutLabel>
          <div>to find one quickly</div>
        </div>
      }
    />
  )
})
